import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export interface FinanceSectionProps {
  title: string;
  description?: string;
  icon?: React.ComponentType<{ className?: string }>;
  badge?: React.ReactNode;
  action?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  headerClassName?: string;
  contentClassName?: string;
}

export function FinanceSection({
  title,
  description,
  icon: Icon,
  badge,
  action,
  children,
  className = "",
  headerClassName = "",
  contentClassName = "",
}: FinanceSectionProps) {
  return (
    <Card className={`shadow-sm border-border/70 ${className}`}>
      {(title || action || badge) && (
        <CardHeader className={`pb-3 ${headerClassName}`}>
          <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
            <div className="space-y-0.5">
              <div className="flex items-center gap-2">
                {Icon && <Icon className="h-4 w-4 text-primary shrink-0" />}
                <CardTitle className="text-base font-semibold tracking-tight">{title}</CardTitle>
                {badge && <div className="ml-1">{badge}</div>}
              </div>
              {description && (
                <p className="text-xs text-muted-foreground leading-relaxed">{description}</p>
              )}
            </div>
            {action && <div className="flex items-center gap-2 shrink-0">{action}</div>}
          </div>
        </CardHeader>
      )}
      <CardContent className={contentClassName}>{children}</CardContent>
    </Card>
  );
}
